/* =========================================
   BARKLYN — Cookie-Banner (Logik)
   Consent liegt ausschließlich in Shopifys Customer Privacy API (kein eigenes Storage):
   Shopify.customerPrivacy.setTrackingConsent / currentVisitorConsent / shouldShowGDPRBanner.
   ACHTUNG: shouldShowBanner() ist nur die statische Händler-Einstellung (display_banner) und bleibt
   auch nach der Entscheidung true → als Trigger ungeeignet (Banner würde bei jedem Seitenaufruf erscheinen).
   Der native Shopify-Banner bleibt im Admin aktiviert (= Wahrheitsquelle, wann Consent nötig ist)
   und wird nur per CSS ausgeblendet; diese Oberfläche ersetzt ihn.
   Öffentliche API: window.BarklynCookies.open() / .close()
   24.10.2026: Banner erscheint, sobald die API bereit ist und cookie-banner.css angewendet ist (nicht mehr erst nach load + idle).
   Mobil rückt er über die Kaufleiste (#stickyAtc), solange diese sichtbar ist (--ck-lift).
   Rückkehr aus dem bfcache (pageshow persisted) prüft den Stand neu.
   ========================================= */
(function () {
  'use strict';

  var root = document.querySelector('[data-ck]');
  if (!root) return;

  var CATS = ['preferences', 'analytics', 'marketing'];
  var state = { preferences: false, analytics: false, marketing: false };
  var cp = null;
  var granular = true;
  var shown = false;
  var manual = false;      // manuell über den Footer geöffnet (Entscheidung existiert bereits)
  var busy = false;
  var lastFocus = null;
  var hideTimer = null;

  // ---------- Anonymer Zähler (seit 20.10.2026) ----------
  // Meldet nur ein Ereignis-Wort an unseren Cloudflare-Worker (consent-counter/), der Tagessummen +1 zählt.
  // Keine Cookies, kein Speicher, keine IDs, kein Referrer (no-referrer), keine Cookies (credentials: omit).
  // Gezählt wird nur der automatische Banner (erster Besuch), nicht das spätere Öffnen über „Cookie-Einstellungen“.
  var COUNT_URL = root.getAttribute('data-ck-count') || '';
  function count(ev) {
    if (!COUNT_URL) return;
    try {
      if (window.fetch) {
        fetch(COUNT_URL, { method: 'POST', body: ev, keepalive: true, mode: 'cors', credentials: 'omit',
          referrerPolicy: 'no-referrer', headers: { 'Content-Type': 'text/plain' } }).catch(function () {});
        return;
      }
      if (navigator.sendBeacon) navigator.sendBeacon(COUNT_URL, new Blob([ev], { type: 'text/plain' }));
    } catch (e) {}
  }

  function $(sel) { return root.querySelector(sel); }
  function $$(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  var els = {
    title: $('#ckTitle'),
    prefsTitle: $('[data-ck-prefs-title]'),
    prefsBtn: $('[data-ck-prefs]'),
    error: $('[data-ck-error]'),
    toggles: $$('[data-ck-toggle]')
  };

  // ---------- Shopify Customer Privacy API ----------
  function withApi(cb) {
    var tries = 0;
    (function attempt() {
      if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
        cp = window.Shopify.customerPrivacy;      // schon geladen (Shopify lädt die API selbst) → nicht auf loadFeatures warten
        cb();
      } else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
          if (err) return;
          cp = window.Shopify.customerPrivacy;
          if (cp) cb();
        });
      } else if (tries++ < 100) {
        setTimeout(attempt, 50);
      }
    })();
  }

  function readConsent() {
    var c = (cp && typeof cp.currentVisitorConsent === 'function') ? cp.currentVisitorConsent() : {};
    CATS.forEach(function (k) { state[k] = !!c && c[k] === 'yes'; });
  }

  function commit(values, ev) {
    if (!cp || busy) return;
    var countIt = !manual && ev;
    // Widerruf: Pixel, die mit der alten Zustimmung schon auf dieser Seite laufen, beendet erst ein Neuladen
    var had = (typeof cp.currentVisitorConsent === 'function') ? (cp.currentVisitorConsent() || {}) : {};
    var revoke = (had.marketing === 'yes' && !values.marketing) || (had.analytics === 'yes' && !values.analytics);
    setBusy(true);
    els.error.hidden = true;
    var payload = granular
      ? {
          marketing: !!values.marketing,
          analytics: !!values.analytics,
          preferences: !!values.preferences,
          sale_of_data: !!values.marketing
        }
      : !!(values.marketing || values.analytics || values.preferences);
    try {
      cp.setTrackingConsent(payload, function (err) {
        setBusy(false);
        if (err) { els.error.hidden = false; return; }
        if (countIt) count(ev);
        if (revoke) { location.reload(); return; }
        hide();
      });
    } catch (e) {
      setBusy(false);
      els.error.hidden = false;
    }
  }

  function setBusy(on) {
    busy = on;
    $$('.ck-btn').forEach(function (b) { b.disabled = on; });
  }

  // ---------- Darstellung ----------
  function render() {
    els.toggles.forEach(function (t) {
      t.setAttribute('aria-checked', state[t.getAttribute('data-ck-toggle')] ? 'true' : 'false');
    });
  }

  function setPrefs(on, moveFocus) {
    root.classList.toggle('is-prefs', on);
    els.prefsBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
    if (!moveFocus) return;
    var target = on ? els.prefsTitle : els.title;
    setTimeout(function () { if (target) target.focus({ preventScroll: true }); }, 60);
  }

  function show(opts) {
    opts = opts || {};
    clearTimeout(hideTimer);
    manual = !!opts.manual;
    root.classList.toggle('is-manual', manual);
    els.error.hidden = true;
    readConsent();
    render();
    setPrefs(!!opts.prefs && granular, false);
    root.hidden = false;
    document.body.classList.add('ck-open');      // blendet Klaviyo-Teaser aus, solange der Banner offen ist
    root.classList.remove('is-out');
    // zwei Frames: erst Startzustand malen, dann Übergang starten
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { root.classList.add('is-in'); });
    });
    shown = true;
    watchSticky();
    if (manual) setTimeout(function () { els.title.focus({ preventScroll: true }); }, 80);
  }

  // ---------- Kaufleiste (#stickyAtc, nur mobil sichtbar): Banner liegt darüber, nie darauf ----------
  var sticky = null, stickyMo = null, stickyRo = null;
  function applyLift() {
    var h = 0;
    if (shown && sticky && sticky.classList.contains('is-visible') && getComputedStyle(sticky).display !== 'none') {
      h = Math.round(sticky.offsetHeight);
    }
    root.style.setProperty('--ck-lift', h + 'px');
    root.classList.toggle('is-lifted', h > 0);
  }
  function watchSticky() {
    if (!sticky) sticky = document.getElementById('stickyAtc');
    if (!sticky) return;
    if (!stickyMo && 'MutationObserver' in window) {
      stickyMo = new MutationObserver(applyLift);
      stickyMo.observe(sticky, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
      if ('ResizeObserver' in window) { stickyRo = new ResizeObserver(applyLift); stickyRo.observe(sticky); }
      window.addEventListener('resize', applyLift, { passive: true });
    }
    applyLift();
  }

  function hide() {
    if (!shown) return;
    shown = false;
    root.classList.remove('is-in');
    root.classList.add('is-out');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () {
      root.hidden = true;
      document.body.classList.remove('ck-open');
      root.classList.remove('is-out', 'is-prefs', 'is-manual', 'is-lifted');
      root.style.removeProperty('--ck-lift');
      if (manual && lastFocus && document.body.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
      manual = false;
    }, 320);
  }

  // ---------- Events ----------
  root.addEventListener('click', function (e) {
    var t = e.target.closest('button');
    if (!t || !root.contains(t)) return;

    if (t.hasAttribute('data-ck-accept')) {
      commit({ marketing: true, analytics: true, preferences: true }, 'accept_all');
    } else if (t.hasAttribute('data-ck-reject')) {
      commit({ marketing: false, analytics: false, preferences: false }, 'reject');
    } else if (t.hasAttribute('data-ck-save')) {
      commit(state, state.marketing ? 'settings_saved_mkt_on' : 'settings_saved_mkt_off');
    } else if (t.hasAttribute('data-ck-prefs')) {
      setPrefs(true, true);
    } else if (t.hasAttribute('data-ck-back')) {
      setPrefs(false, true);
    } else if (t.hasAttribute('data-ck-close')) {
      hide();
    } else if (t.hasAttribute('data-ck-toggle')) {
      var k = t.getAttribute('data-ck-toggle');
      state[k] = !state[k];
      render();
    }
  });

  root.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (manual) {                                   // Widerruf über den Footer: Esc schließt direkt, Entscheidung bleibt bestehen
      e.stopPropagation();
      hide();
    } else if (root.classList.contains('is-prefs')) {
      e.stopPropagation();
      setPrefs(false, true);
    }
    // Erstbesuch, Hauptansicht: Esc = keine Entscheidung → Banner bleibt (kein Consent durch Wegklicken)
  });

  // Footer-Link „Cookie-Einstellungen" (Widerruf jederzeit)
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-ck-open]');
    if (!trigger) return;
    e.preventDefault();
    api.open(trigger);
  });

  // Consent wurde anderswo gesetzt (anderer Tab / Widget) → Banner einklappen
  document.addEventListener('visitorConsentCollected', function () {
    if (shown && !busy) hide();
  });

  // ---------- Öffentliche API ----------
  var api = {
    open: function (trigger) {
      // Erstbanner ist schon offen (noch keine Entscheidung): nur die Einstellungen aufklappen, nicht „manuell“ machen
      // → kein X ohne Wahl, und die Entscheidung wird weiter gezählt
      if (shown && !manual) { if (granular) setPrefs(true, true); return; }
      lastFocus = trigger && trigger.focus ? trigger : document.activeElement;
      if (!cp) { withApi(function () { granular = cp.doesMerchantSupportGranularConsent ? !!cp.doesMerchantSupportGranularConsent() : true; applyGranular(); show({ manual: true, prefs: true }); }); return; }
      show({ manual: true, prefs: true });
    },
    close: hide
  };
  window.BarklynCookies = api;

  function applyGranular() {
    els.prefsBtn.hidden = !granular;
  }

  // ---------- Start ----------
  // Besucher hat noch nicht entschieden UND Region verlangt Consent.
  function needsDecision() {
    if (typeof cp.shouldShowGDPRBanner === 'function') return !!cp.shouldShowGDPRBanner();
    return typeof cp.shouldShowBanner === 'function' && !!cp.shouldShowBanner() &&
      typeof cp.getTrackingConsent === 'function' && cp.getTrackingConsent() === 'no_interaction';
  }

  // cookie-banner.css lädt asynchron → erst zeigen, wenn sie angewendet ist (sonst kurz ungestylter Banner).
  // Kein Warten auf load/idle mehr; spätestens nach 4 s trotzdem zeigen (Inline-Notfall-CSS im Snippet).
  function whenStyled(fn) {
    var done = false, waited = 0;
    function ready() { return getComputedStyle(root).getPropertyValue('--ck-css').trim() === '1'; }
    function go() { if (done) return; done = true; fn(); }
    if (ready()) return go();
    var link = document.querySelector('link[href*="cookie-banner"][rel="stylesheet"]');
    if (link) link.addEventListener('load', function () { requestAnimationFrame(function () { if (ready()) go(); }); });
    (function poll() {
      if (done) return;
      if (ready() || (waited += 50) >= 4000) return go();
      setTimeout(poll, 50);
    })();
  }

  withApi(function () {
    granular = typeof cp.doesMerchantSupportGranularConsent === 'function' ? !!cp.doesMerchantSupportGranularConsent() : true;
    applyGranular();
    if (needsDecision()) {
      whenStyled(function () {
        if (needsDecision()) { show({ manual: false, prefs: false }); count('banner_shown'); }   // erneut prüfen: Consent kann inzwischen anderswo gesetzt worden sein
      });
    }
  });

  // Zurück/Vor aus dem Browser-Zwischenspeicher (bfcache): Seite kommt ohne neuen Start zurück → Stand neu prüfen.
  // Keine Entscheidung → Banner wieder zeigen (wie bei jedem neuen Seitenaufruf); inzwischen entschieden → Erstbanner einklappen.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted || !cp || busy) return;
    if (needsDecision()) {
      if (!shown) whenStyled(function () { if (!shown && needsDecision()) { show({ manual: false, prefs: false }); count('banner_shown'); } });
    } else if (shown && !manual) {
      hide();
    }
  });
})();
